import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { addAddress, addVehicle } from "../../redux/action/customers";
import { useDispatch } from "react-redux";
import Autocomplete from "react-google-autocomplete";

const AddAddress = (props) => {
  const dispatch = useDispatch();
  const [location, setLocation] = useState();
  const [locationText, setLocationText] = useState("");
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [lat, setLat] = useState();
  const [lon, setLon] = useState();
  const data = location?.formatted_address?.split(",");
  const userID = props.userID;

  const resetForms = () => {
    document.getElementById("myForm").reset();
  };

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 d-flex">
              <div className="text-center">
                <h1 className=" text-primary">Add Address</h1>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  resetForms();
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="col-xl-12">
                <div className="fs-6 fw-bold mt-2 mb-3">Enter a location</div>
              </div>
              <Autocomplete
                apiKey={"AIzaSyBVq1YHt0rZrbQGLXL9CdL2VeU9kjtfO4I"}
                style={{ width: "100%" }}
                onPlaceSelected={(place) => {
                  place.address_components.forEach((component) => {
                    if (component.types.includes("locality")) {
                      setCity(component.long_name);
                    } else if (
                      component.types.includes("administrative_area_level_1")
                    ) {
                      setState(component.long_name);
                    }
                  });
                  setLocation(place);
                  setLat(place.geometry.location.lat());
                  setLon(place.geometry.location.lng());
                }}
                onChange={(e) => setLocationText(e.target.value)}
                componentRestrictions={{ country: "bs" }}
                options={{
                  // types: ["geocode", "establishment"],
                  types: ["(cities)"],
                  componentRestrictions: { country: "bs" },
                }}
                className="form-control form-control-solid"
                placeholder="Enter Your Address"
              />
              <div className="modal-body p-0">
                <Formik
                  initialValues={{
                    street: data?.[0],
                    appartment: data?.[1],
                    city: data?.[2],
                    lat: lat,
                    lon: lon,
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    values.address = location?.formatted_address;
                    values.city = data?.[2];
                    values.lat = lat;
                    values.lon = lon;
                    dispatch(addAddress(values, userID));
                    setSubmitting(false);
                    resetForm();
                    resetForms();
                  }}
                >
                  {({ values, handleBlur, handleChange, handleSubmit }) => (
                    <form className="form">
                      <div className="row mb-2 mt-5">
                        {/* <div className="col-xl-12">
                          <div className="fs-6 fw-bold mt-2 mb-3">Street</div>
                        </div> */}
                        <div className="col-xl-12 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="street"
                            id="street"
                            defaultValue={city}
                            placeholder="Street no"
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        {/* <div className="col-xl-12">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            Appartment, Building
                          </div>
                        </div> */}
                        <div className="membership-form-check col-xl-12 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="appartment"
                            id="appartment"
                            defaultValue={state}
                            placeholder="Appartment, building no"
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="membership-form-check col-xl-12 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            name="appartment"
                            id="appartment"
                            defaultValue={"The Bahamas"}
                            disabled
                            placeholder="Country"
                          />
                        </div>
                      </div>
                      <div className="mb-6"></div>
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={handleSubmit}
                          type="submit"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          disabled={!location && !locationText?.trim()}
                        >
                          <span className="indicator-label">Save</span>
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddAddress;
